import { action, makeObservable, observable } from "mobx";
import OrganisationsApi, {
  OrganisationsApi as IOrganisationsApi
} from "../../../../../../../../services/api/v2/organisations/Organisations.api";
import PermissionsContext from "../../../../../../../../contexts/permissions/PermissionsContext";
import { PermissionFields } from "../../../../../../../../contexts/permissions/PermissionsTypes";
import I18n from "../../../../../../../localization/I18n";
import { IModalContextModel } from "../../../../../../../modalZ/context/IModalContext";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";
import { UiActionRenderers } from "../../../../../../../uiAction/IUiAction";
import { BaseModel } from "../../../../../../../util/BaseModel";
import ProjectProcessesApi, {
  ProjectProcessesApi as IProjectProcessesApi
} from "../../../../../../../../services/api/v2/projectProcesses/ProjectProcesses.api";
import LocationsApi, {
  LocationsApi as ILocationsApi
} from "../../../../../../../../services/api/v2/locations/Locations.api";
import { getProjectProcessLocationsPopupFormFields } from "./ProjectProcessLocationsPopup_fields";
import { SingleFormModel } from "../../../../../../../../pages/change/forms/singleFormModel/SingleForm_model";

export class ProjectProcessLocationsPopupModel extends BaseModel {
  projectProcessProvider: IProjectProcessesApi;
  modalService: IModalContextModel;
  locationsProvider: ILocationsApi;
  organisationsProvider: IOrganisationsApi;
  @observable isLoading: boolean = true;
  @observable.ref projectProcess: FP.Entities.IProjectProcess;
  organisationId: number;
  projectId: number;
  @observable locationTreeData: FP.Entities.ITreeDataItem[];
  canEdit: boolean;
  @observable.ref formModel: SingleFormModel;
  onSubmit: (locationIds: number[]) => void;
  actions = [
    {
      id: "action1",
      label: I18n.t("phrases.done"),
      onAction: ev => {
        this.submitForm();
      },
      componentProps: {
        className: "ml-auto"
      },
      rendersIn: UiActionRenderers.BUTTON
    }
  ];

  constructor(organisationId: number, projectId: number, onSubmit: (locationIds: number[]) => void) {
    super();
    makeObservable(this);
    this.locationsProvider = LocationsApi;
    this.organisationsProvider = OrganisationsApi;
    this.organisationId = organisationId;
    this.modalService = ModalContext;
    this.onSubmit = onSubmit;
    this.projectId = projectId;
    this.projectProcessProvider = ProjectProcessesApi;
    this.loadPopup();
    this.canEdit = PermissionsContext.canEditField(PermissionFields.PROCESSES, this.organisationId, this.projectId);
  }

  submitForm = async () => {
    let res = await this.formModel.submit();
    this.onSubmit(res.locations);
    this.modalService.hide();
  };

  @action
  getOrgLocations = async () => {
    let res = await this.organisationsProvider.getLocations(this.organisationId);
    if (!res || res.isError) return;
    let k = res.payload.map(e => {
      return { ...e, label: e.name };
    });
    this.locationTreeData = k as any[];
  };

  @action
  loadPopup = async () => {
    this.setIsLoading(true);
    await this.getOrgLocations();
    this.formModel = new SingleFormModel();
    this.formModel.formFields = getProjectProcessLocationsPopupFormFields(this.locationTreeData);
    this.formModel.actions = this.actions;
    this.setIsLoading(false);
  };

  @action
  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };
}
